import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class History extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get date() {
    return get(this, '_data.value', '');
  }

  get title() {
    return get(this, '_tytul.value', '');
  }

  get subtitle() {
    return get(this, '_podtytul.value', '');
  }

  get text() {
    return get(this, '_tresc.value', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/History.js